export default "__VITE_ASSET__CjrGRWCa__"